import { Environment } from '@app-utils';

export const environment: Environment = {
  prod: false,
  apiBase: 'https://api.aureliusconsilium.com.au',
};
